import { render, staticRenderFns } from "./Attributions.vue?vue&type=template&id=3829f775&scoped=true&"
import script from "./Attributions.vue?vue&type=script&lang=js&"
export * from "./Attributions.vue?vue&type=script&lang=js&"
import style0 from "./Attributions.vue?vue&type=style&index=0&id=3829f775&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3829f775",
  null
  
)

export default component.exports